<div
  style="display: flex; gap: 10px"
  [attr.class]="
    type
      ? type.includes('Alert')
        ? 'alert alert-' + type.substring(0, type.length - 5)
        : 'alert alert-' + type
      : ''
  "
  [attr.role]="type ? (type.includes('Alert') || type === 'error' ? 'alert' : 'region') : ''"
  [class.alert--show-icon]="showIcon"
  [attr.aria-label]="
    type
      ? type.includes('Alert') || type === 'error'
        ? type.includes('success')
          ? 'succes'
          : 'advarsels'
        : 'Information'
      : ''
  "
  [hidden]="
    !(titleHtml || descriptionHtml || titleValue || descriptionValue || descriptionHtmlSanitized)
  "
>
  <i *ngIf="showWarningIcon" class="icon icon-warning"></i>
  <div class="alert-body" [class.has-heading]="!!titleKey || !!titleHtml">
    <strong class="alert-heading" *ngIf="titleKey" [innerHtml]="titleValue"></strong>
    <strong class="alert-heading" *ngIf="titleHtml" [innerHtml]="titleHtml"></strong>
    <p class="alert-text" *ngIf="descriptionKey" [innerHtml]="descriptionValue"></p>
    <p class="alert-text" *ngIf="descriptionHtml" [innerHtml]="descriptionHtml"></p>
    <p class="alert-text" *ngIf="descriptionHtmlSanitized">
      {{ descriptionHtmlSanitized }}
    </p>
    <a *ngIf="showCloseButton" href="#" class="button-close mt-4 mr-4" (click)="!!close()">
      {{ '_Close' | tekstresource }}
    </a>
    <div
      class="alert-text"
      style="display: flex; justify-content: space-between; align-items: center; max-width: 100%"
    >
      <ng-content></ng-content>
    </div>
  </div>
</div>
